import React from "react";
import { withTranslation } from "react-i18next";

import IntroductionImage from "../../assets/images/quiz/Klimaquiz_Keyvisual.svg";

const QuizIntroduction = ({ t, next }) => (
  <>
    <img src={IntroductionImage} />
    <p>{t("quiz.introduction.description")}</p>
    <button
      className="btn btn-info"
      data-gtm="quiz-start"
      onClick={() => next()}
    >
      {t("quiz.introduction.next")}
    </button>
  </>
);

export default withTranslation()(QuizIntroduction);
